export const messages = {
  en: {
    editAllocationStorehouseApply: {
      title: 'Allocation Application',
      back: 'Back',
      applyRemark: 'Application Description',
      remarkPlaceholder: 'Required, please fill in the application description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      resourceType: 'Resource Type',
      resourceName: 'Resource Name',
      specification: 'Specification',
      isFixed: 'Fixed Resource',
      sourceWarehouse: 'Source Warehouse',
      referencePrice: 'Reference Price',
      selectPrice: 'Select Price',
      stock: 'Stock',
      targetWarehouse: 'Target Warehouse',
      selectTargetWarehouse: 'Required, select target warehouse',
      allocationQuantity: 'Allocation Quantity',
      allocationQuantityPlaceholder: 'Required, fill in allocation quantity',
      operation: 'Operation',
      cancelAllocation: 'Cancel Allocation',
      submit: 'Submit',
      noPurchaseItems: 'No purchase items selected',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed'
    }
  },
  zh: {
    editAllocationStorehouseApply: {
      title: '调拨申请',
      back: '返回',
      applyRemark: '申请说明',
      remarkPlaceholder: '必填，请填写申请说明',
      purchaseItems: '采购物品',
      select: '选择',
      resourceType: '物品类型',
      resourceName: '物品名称',
      specification: '物品规格',
      isFixed: '固定物品',
      sourceWarehouse: '源仓库',
      referencePrice: '参考价格',
      selectPrice: '请选择价格',
      stock: '库存',
      targetWarehouse: '目标仓库',
      selectTargetWarehouse: '必填，请选择目标仓库',
      allocationQuantity: '调拨数量',
      allocationQuantityPlaceholder: '必填，请填写调拨数量',
      operation: '操作',
      cancelAllocation: '取消调拨',
      submit: '提交',
      noPurchaseItems: '未选择采购物品',
      updateSuccess: '修改成功',
      updateFailed: '修改失败'
    }
  }
}